var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSidebaricon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 68,
    viewBox: "0 0 66 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_813_3071)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.3169 43.8536H48.2926V40.6341H19.3169V43.8536ZM19.3169 35.8048H48.2926V32.5853H19.3169V35.8048ZM19.3169 24.5365V27.756H48.2926V24.5365H19.3169Z",
    fill: "#17335E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_813_3071"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38.6343,
    height: 38.6343,
    fill: "white",
    transform: "translate(14.4878 14.8779)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebaricon);
export default __webpack_public_path__ + "static/media/sidebaricon.4fe00e3ba7c384987ed6bf489af35e7c.svg";
export { ForwardRef as ReactComponent };